function descendingComparator(a, b, orderBy) {
  const aValue = getSafeValue(a, orderBy);
  const bValue = getSafeValue(b, orderBy);

  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
}

function getSafeValue(o = {}, orderBy) {
  return o[orderBy] === undefined
    ? Number.POSITIVE_INFINITY
    : o[orderBy];
}

const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export { getComparator, descendingComparator, stableSort };
